import { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from "react-router-dom";
import useProjectStore from "../../../hooks/useProjectStore";
import SummaryProjectTemplate from "../../Templates/SummaryProject";
import Swal from "sweetalert2";
import ProjectService from "../../../services/Projects/ProjectService";

export default function SummaryProjectPage() {
    const navigate = useNavigate();
    const { isFormValid, setProjectSummary, projectDataStore } = useProjectStore();
    const { keycloak, initialized } = useKeycloak();

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isFormValid()) {
            Swal.fire({
                position: "top-end",
                title: "Você não possui nenhum rascunho salvo",
                showConfirmButton: false,
                timer: 2000,
                background: '#27272A',
                color: '#fff',
            });

            navigate('/projects');
        } else {
            generateSummary();
        }
    }, [initialized, keycloak.token]);

    const generateSummary = async () => {
        try {
            if (initialized && keycloak.token) {
                setLoading(true);
                
                const summary = await ProjectService.generateSummary(projectDataStore, keycloak);
                if (summary) {
                    Swal.fire({
                        position: "top-end",
                        title: "Resumo gerado com sucesso",
                        showConfirmButton: false,
                        timer: 1800,
                        background: '#27272A',
                        color: '#fff',
                    });
                    setProjectSummary(summary);
                }
                setLoading(false);
            }
        } catch (error) {
            Swal.fire({
                position: "top-end",
                title: "Erro ao gerar resumo",
                showConfirmButton: false,
                timer: 1800,
                background: '#27272A',
                color: '#fff',
            });
            setLoading(false);
        }
    }

    return (
        <SummaryProjectTemplate
            generateSummary={generateSummary}
            loading={loading}
        />
    )
}